import axios from 'axios'
import store from '@/store'

const API_BASE = 'https://residencial-services.intrare.app'

/**
 * Servicio para manejar los chats directos del Vigilante
 */
export default {
  /**
   * Crea un nuevo chat directo entre vigilante y residente
   * @param {string|number} idVigilant
   * @param {string|number} idResident
   */
  async createDirectChat (idVigilant, idResident) {
    const response = await axios.post(`${API_BASE}/direct-chats/`, {
      idVigilant,
      idResident
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${store.getters.getToken}`
      }
    })
    return response.data
  },

  /**
   * Lista todos los chats directos del vigilante
   */
  async getDirectChats () {
    const response = await axios.get(`${API_BASE}/direct-chats/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${store.getters.getToken}`
      }
    })
    return response.data
  },

  /**
   * Obtiene los mensajes de un chat directo con paginación
   * @param {string} idDirectChat - UUID del chat directo
   * @param {number} page - Número de página
   * @param {number} limit - Mensajes por página
   */
  async getDirectMessages (idDirectChat, page = 1, limit = 20) {
    const response = await axios.get(`${API_BASE}/direct-messages/by-chat/paginated/`, {
      params: { idDirectChat, page, limit },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${store.getters.getToken}`
      }
    })
    return response.data
  },

  /**
   * Envía un mensaje en un chat directo
   * @param {string} idDirectChat - UUID del chat directo
   * @param {string} content - Contenido del mensaje
   */
  async sendDirectMessage (idDirectChat, content) {
    const response = await axios.post(`${API_BASE}/direct-messages/`, {
      idDirectChat,
      content
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${store.getters.getToken}`
      }
    })
    return response.data
  }
}
